import React from 'react';
import { BrandHeader } from './BrandHeader';
import { EyebrowLabel } from './EyebrowLabel';
import { OrangeAccent } from './OrangeAccent';
import { WistiaPlayer } from './WistiaPlayer';
import { ClientResults } from './ClientResults';
import { StatsSection } from './StatsSection';
import { FAQSection } from './FAQSection';
import { Footer } from './Footer';
interface LanderShellProps {
  children: ReactNode;
}
export function LanderShell({
  children
}: LanderShellProps) {
  return <div className="w-full min-h-screen flex flex-col" data-id="element-82">
      <BrandHeader data-id="element-83" />

      {/* Centered hero + VSL + quiz + trusted-by, capped at 720px */}
      <main className="w-full max-w-[720px] mx-auto px-4 pb-12 pt-2 flex flex-col items-center text-center" data-id="element-84">
        <EyebrowLabel className="mb-6" data-id="element-85">
          CHIROPRACTORS DOING $40K+ PER MONTH
        </EyebrowLabel>

        <h1 className="font-display font-extrabold text-[clamp(34px,6vw,52px)] tracking-tighter text-ink leading-[1.1] mb-8" data-id="element-86">
          We Install One{' '}
          <span className="text-orange" data-id="element-87">Patient Profit System</span> That Brings{' '}
          20+ Booked, Showed, &amp; Paid Visits A Month — Or We{' '}
          <span className="text-orange" data-id="element-88">Cover Your Ad Spend For 90 Days</span>
        </h1>

        <p className="font-sans font-medium text-[17px] text-ink-soft mb-8 max-w-[600px]" data-id="element-89">
          Step 1: Learn how our <i data-id="element-90">Patient Profit System™</i> builds deeper
          relationships with new & existing patients on autopilot
        </p>

        <div id="vsl-section" className="w-full mb-12 scroll-mt-20" data-id="element-91">
          <WistiaPlayer mediaId="fos1r5cunk" data-id="element-92" />
        </div>

        <OrangeAccent className="mb-8" data-id="element-93" />

        <p className="font-sans font-semibold text-[17px] text-ink mb-8" data-id="element-94">
          Step 2: Apply to see if you qualify
        </p>

        {/* Quiz card slot — only this region changes per route */}
        <section id="apply" className="w-full flex justify-center mb-16 scroll-mt-20" data-id="element-95">
          {children}
        </section>
      </main>

      {/* Full-width sections below the 720px container */}
      <ClientResults data-id="element-96" />
      <StatsSection data-id="element-97" />
      <FAQSection data-id="element-98" />
      <Footer data-id="element-99" />
    </div>;
}